import { FC } from 'react';
import { Table } from '@/components';
import { getTableColumns } from './getTableColumns';
import { AssignListInfo } from '../../types';
import { tableFilters } from './tableFiters';
import styles from './AssignListTable.module.scss';

type AssignListTableProps = {
  data?: AssignListInfo[];
  isLoading?: boolean;
};

const AssignListTable: FC<AssignListTableProps> = ({ data, isLoading }) => {
  const tableColumns = getTableColumns(data);

  return (
    <div className={styles.containerListTable}>
      <Table
        columns={tableColumns}
        data={data}
        isLoading={isLoading}
        filters={tableFilters}
        filterDisplay="menu"
      />
    </div>
  );
};

export default AssignListTable;
